import React from 'react';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { Button } from 'react-bootstrap';

const OpenCallPageButton = ({ callId, compactMode = true }) => {
    const isDisabled = !callId;

    if (!compactMode) {
        return (
            <a
                href={`/calls/${callId}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`ml-2 text-decoration-none ${isDisabled ? 'disabled' : ''}`}
                title="View Call Details"
            >
                <Button variant="outline-primary">
                    <BsBoxArrowUpRight size={14} />
                </Button>
            </a>
        );
    }

    return (
        <a
            href={`/calls/${callId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`p-2 m-0 text-decoration-none ${isDisabled ? 'disabled' : ''}`}
            title="View Call Details"
        >
            <BsBoxArrowUpRight size={14} />
        </a>
    );
};
export default OpenCallPageButton;
